import React from "react";
import Logo from "../../../assets/images/travel-logo.svg";
import Image from "src/components/elements/Image";
import { EnvelopeIcon, GlobeAltIcon, HomeModernIcon, LifebuoyIcon, PhoneIcon, PresentationChartLineIcon, ShieldCheckIcon, Square3Stack3DIcon, UserIcon } from "@heroicons/react/24/outline";
import { NavLink } from "react-router-dom";
import { classNames } from "src/helpers/classNames";

const TravelSidebar = () => {
  const menus = [
    { label: "Home", icon: HomeModernIcon, link: "/travel/home" },
    { label: "My Travel Requests", icon: Square3Stack3DIcon, link: "/travel/requests" },
    { label: "Invoice Retrival", icon: ShieldCheckIcon, link: "/travel/bookings" },
    // { label: "Jyrney", icon: RocketLaunchIcon, link: "/travel/jyrney" },
    { label: "Analytics", icon: PresentationChartLineIcon, link: "/travel/analytics" },
    { label: "Travel Greener", icon: GlobeAltIcon, link: "/travel/greener" },
    { label: "My Profile", icon: UserIcon, link: "/travel/profile" },
    { label: "Help", icon: LifebuoyIcon, link: "/travel/help" },
  ];

  return (
    <div className="flex w-full flex-col">
      <div className="flex h-16 flex-shrink-0 items-center px-8">
        <div className="relative h-12">
          <a
            href="/"
            className="flex h-full w-full">
            <Image
              src={Logo}
              alt={"Travel Image"}
              width={"100%"}
              height={"100%"}
              effect={"blur"}
              classes={"object-contain"}
            />
          </a>
        </div>
      </div>
      <div className="max-h-[calc(100dvh-13rem)] flex-shrink flex-grow overflow-auto">
        <div className="py-6">
          {menus?.length > 0 && (
            <div className="space-y-1 pr-4">
              {menus?.map((item, index) => (
                <NavLink
                  key={index}
                  to={item?.link}
                  className={({ isActive }) => classNames("flex h-14 w-full items-center space-x-4 rounded-r-full px-8 transition", isActive ? "bg-gradient-to-b from-[#f5f0fd] to-[#e3dffd] text-[#572f5f] shadow" : "text-white/50 hover:bg-white/10 hover:text-white")}>
                  {({ isActive }) => (
                    <>
                      <item.icon className={classNames("h-6 w-6", isActive ? "stroke-2 text-[#572f5f]" : "text-white/50")} />
                      <span className={classNames("text-lg", isActive ? "font-semibold" : "font-medium")}>{item?.label}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="flex h-36 flex-col justify-center space-y-2 border-t border-white/10 px-4 pb-8 pt-4">
        <div className="text-lg font-medium text-white">Need Help?</div>
        <div className="flex flex-col justify-start space-y-1">
          <div className="flex items-center space-x-3 text-base text-white/50 transition-all hover:text-white/80">
            <PhoneIcon className="h-4 w-4 stroke-2" />
            <a
              href="tel:+44 (0)1892 616 122"
              className="">
              +44 (0)1892 616 122
            </a>
          </div>
          <div className="flex items-center space-x-3 text-base text-white/50 transition-all hover:text-white/80">
            <EnvelopeIcon className="h-4 w-4 stroke-2" />
            <a
              href="mailto:enquire@ctbusinesstravel.co.uk"
              className="">
              enquire@ctbusinesstravel.co.uk
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelSidebar;
